import type { GalleryGoalOption } from "./galleryGoals";

// The five goals the signed artist design lists (App Onboarding.dc.html, `GOALS.artist`), in that
// order. Values are SignupIntent flags, so a selection is the same bitmask the registration POST
// has always carried. `analyticsLabel` carries the same weight it does in galleryGoals.ts (see that
// file's GalleryGoalOption doc): it is the word `Intent.displayType()` puts in
// page/Onboarding.jsx's `'OB: Intent Declared'` payload, not the chip's own copy - both wizards
// feed the same ACA-95 funnel.
//
// No ordinal for User.Type travels with this table: POST /registrations/account always creates
// UserType.Artist server-side, whatever goals are picked.
//
// `Consignments` (128) is reused on purpose, not duplicated by accident. ACA-266 minted that flag
// for the gallery's "Handle consignments" goal; "Consign to galleries" is the artist side of the
// same transaction, so the two lists sharing this one bit is a decision, not an automatism.
export const ARTIST_GOALS: readonly GalleryGoalOption[] = [
  { value: 256, label: "Catalogue my works", analyticsLabel: "Catalogue" }, // Catalogue
  { value: 128, label: "Consign to galleries", analyticsLabel: "Consignments" }, // Consignments (reused, see above)
  { value: 512, label: "Track sales", analyticsLabel: "Track Sales" }, // TrackSales
  { value: 2, label: "Send email campaigns", analyticsLabel: "Email Campaign" }, // EmailCampaign
  { value: 4, label: "Create collateral", analyticsLabel: "Collateral" }, // Collateral
] as const;
